import React, { Component } from 'react';
import { Container, Row, Col, Table, ProgressBar, Carousel } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCurrentProfile } from '../../actions/profileAction';
import Card from '../../components/Card/Card';
import Spinner from '../common/Spinner';
import { getStudentStats } from '../../actions/clientActions';
import { StatsCard } from '../StatsCard/StatsCard';
import CountUp from 'react-countup';
import { Slide } from 'react-awesome-reveal';
import axios from 'axios';
import Confetti from 'react-confetti'
var dateFromObjectId = function (objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};
class StudentStatPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: '',
      numberOfConferences: 0,
    };
  }

  componentDidMount() {
    this.props.getCurrentProfile();
    const email = this.props.auth.user.email;
    this.props.getStudentStats(email);
    axios.post(`/api/clients/getNumberOfConferences/`)
      .then(resp => {
        this.setState({ numberOfConferences: resp.data })
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    let jupii;
    const { loading } = this.props.student;
    const students = this.props.participant.participantOwnStats;
    //console.log(students);
    let studentItems;
    if (students === null || loading) {
      studentItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }
    else {
      if (students.length > 0) {
        console.log(students.length);
        //if (students.length >= 6) {
        //jupii = <Confetti />;
        //var sertifikat = "Čestitamo, dobijate sertifikat!";
        //console.log(sertifikat);
        //}
        //else {
        //var sertifikat = "Za dobijanje sertifikata potrebno Vam je prisustvo na 6 od 8 predavanja!";
        //}
        studentItems = students.map(student => (
          <Carousel.Item interval={3000} key={student._id} style={{ background: 'linear-gradient(180deg, hsla(34, 61%, 92%, 1) 0%, hsla(13, 44%, 77%, 1) 68%, hsla(336, 27%, 56%, 1) 100%)' }}>
            <div className='text-center' style={{ background: 'linear-gradient(90deg, hsla(218, 25%, 28%, 1) 0%, hsla(210, 32%, 71%, 1) 100%)', height: '250px' }}>

            </div>
            <Carousel.Caption>
              <h3>{student.conference}</h3>
              <p>{student.speaker}</p>
              <small>{dateFromObjectId(student._id).toLocaleDateString("en-GB")} {dateFromObjectId(student._id).toLocaleTimeString("en-GB")}</small>
            </Carousel.Caption>
          </Carousel.Item>
        ));
      }
      else {
        studentItems = (
          <tr>
            <td>Jos uvek niste posetili nijedno predavanje</td>
          </tr>

        );
      }
    }
    //console.log(studentItems)
    return (
      <div className="content"> {jupii}
        <Slide triggerOnce>
          <Row className='justify-content-center'>
            <Col lg={4} sm={3}>
              <StatsCard
                bigIcon={<i className="pe-7s-study" />}
                statsText="Broj prisustva"
                statsValue={
                  <CountUp
                    className="account-balance"
                    start={0}
                    end={students.length}
                    duration={2}
                    useGrouping={true}
                  />}
              //statsIconText={sertifikat}
              />
              <ProgressBar animated now={students.length} max={this.state.numberOfConferences} />
            </Col>
          </Row>
        </Slide>
        <hr></hr>
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Prisustvo na predavanjima"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Slide triggerOnce>
                    <Carousel>
                      {studentItems}
                    </Carousel>
                  </Slide>
                }

              />
            </Col>
          </Row>
        </Container>

      </div>
    );
  }
}

StudentStatPage.propTypes = {
  student: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  getStudentStats: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  student: state.student,
  participant: state.participant,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { getCurrentProfile, getStudentStats }
)(StudentStatPage);
